let signingCompleteObserved = false;

export function markSigningCompleteObserved(): void {
    signingCompleteObserved = true;
}

export function consumeSigningCompleteObserved(): boolean {
    const observed = signingCompleteObserved;
    signingCompleteObserved = false;
    return observed;
}
